export default [
    {
        to: "/app", layout: "/sidebar", children: [
            {to: "/app/dashboard", text: "首页", component: "dashboard"},
            {to: "/app/sieve/:level/:category", component: "task"},
            {to: "/app/sieve/:level/list", component: "task"},
            {to: "/app/sieve/:level/create/:category", component: "task/create"},
            {to: "/app/sieve/:level/create/:category/fb/:batchId", component: "task/create"},
            {to: "/app/sieve/:level/create", component: "task/create"},
            {to: "/app/remit", text: "首页", component: "remit"},
            {to: "/app/sieve/:category/batch", text: "检测", component: '/detection'},
            {to: "/app/sieve/:category/single", text: "单条记录", component : "/record/single"},
            {to: "/app/sieve/:category/batch/create", text: "检测", component: '/detection/create'},
            {to: "/app/sieve/:category/batch/create/fb/:batchId", text: "检测", component: '/detection/create'},
            {to: "/app/record/batch/:tag", text: "多条记录", component : "/record/batch"},
            {to: "/app/record/statistics", text: "统计报表", component : "/record/statistics"},
            {to: "/app/finance/recharge/:type", text: "充值管理", component : "/finance/recharge"},
            {to: "/app/finance/consume/customer", text: "消耗管理", component : "/finance/consume"},
            {to: "/app/tools/shunt", component: "/tools/shunt"},
            {to: "/app/tools/match", component: "/tools/match"},
            {to: "/app/tools/usca", component: "/tools/usca"},
            {to: "/app/tools/area", component: "/tools/area"},
            {to: "/app/tools/filter", component: "/tools/filter"},
            {to: "/app/tools/create/special", component: "/tools/create0"},
            {to: "/app/tools/create/random", component: "/tools/create1"},
            {to: "/app/notice", component: "/notice"}
        ]
    },
    {to: "/login", component: "/login/user", text: "客户登陆"},
    {to: "/register", component: "register", text: "客户登陆"},
    {to: "/login.html", component: "/login/user", text: "客户登陆"},
    {to: "/console/login.html", component: "/login/user", text: "客户登陆"},
    {to: "/anonymous", component: "/anonymous", text: "匿名操作"}
]
